import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import axios from '../../../../_services/api/axios';
import withErrorHandler from '../../../../_hoc/withErrorHandler';
import * as actionCreators from '../../../../_store/actions/index';
import { getTranslate } from 'react-localize-redux';

import { GreyBox, Modal, Button, BoxTitle, Flex, FlexColumn, Form, Text, Accordion, AccordionSection, Spacer, Icon } from 'components'

import { secondsFormatter, dateFormatter } from '../../../../_helpers/DateTime.js';


class DetailedCalculationModal extends Component {
	state = {
        modalContent : "",
        accordionState: "closed",
        accordionSettingsState: "closed"
    }
	constructor(props) {
        super(props);
    }
    componentDidMount = () => {
        this.props.onCalculatorJobDetailedCalculation(this.props.jobId, this.props.calculationId);
    }
    componentDidUpdate = (prevProps, prevState, snapshot) => {
    	if(prevProps.state.detailed_calculation.fetched !== this.props.state.detailed_calculation.fetched && this.props.state.detailed_calculation.fetched) {
    		this.handleModalContent();
    	}
    	else if(prevProps.state.detailed_calculation.error !== this.props.state.detailed_calculation.error) {
    		this.onCloseModal();
    	}  	
    }
	componentWillUnmount = () => {
		this.props.onCalculatorJobDetailedCalculationReset();
	}

    onCloseModal = () => {
        this.props.onCloseModal();
    }



    onToggleAllAccorions = () => {
    	if(this.state.accordionState == "open"){
    		this.setState({accordionState: "closed"}, () => {
    			this.handleModalContent();
    		})
    	}else if(this.state.accordionState == "closed"){
    		this.setState({accordionState: "open"}, () => {
    			this.handleModalContent();
    		})
    	}

    
    }

	round(number, length) {

	  let factor = Math.pow(10, length);
	  let rounded = Math.round(number * factor) / factor
	  return rounded
	}

    handleModalContent = () => {
    	if(this.props.state.detailed_calculation.fetched) {
    		console.log(this.props.state.detailed_calculation.details)
    		this.setState(prevState => ({
    			modalContent : (
	    			<Modal show={true}>
		                <GreyBox outerMargin="true" closeIcon={this.onCloseModal} cols="2" title={this.props.translate('detailedcalculationmodal.title')} titleTheme="light">
		                	<Flex>
			                	<FlexColumn col="5*3">
		                			<BoxTitle>{this.props.state.detailed_calculation.details.calculation.name}</BoxTitle>
			                		<Text>{this.props.translate('detailedcalculationmodal.box_text')}</Text>
								</FlexColumn>
								<FlexColumn col="5*2" align="right" >
									<Button width="auto" nomargin="true" onClick={this.onToggleAllAccorions} theme="dark" value={this.state.accordionState == "open" ? this.props.translate('detailedcalculationmodal.details.accordion_all_close') : this.props.translate('detailedcalculationmodal.details.accordion_all_expand')} />
								</FlexColumn>
							</Flex>
							<Spacer height="24px"/>
							<Accordion>
								<AccordionSection globalState={this.state.accordionState} title={this.props.translate('detailedcalculationmodal.settings.title')}>
									<article>
									{this.props.translate('global.form.label.machine.heads')}
									<div>{this.props.state.detailed_calculation.details.machine.heads} {this.props.translate('global.units.heads')}</div>
									</article>
									<article>
									{this.props.translate('global.form.label.machine.speed')}
									<div>{this.props.state.detailed_calculation.details.machine.settings.speed} {this.props.translate('global.units.spm')}</div>
									</article>
									<article>
									{this.props.translate('global.form.label.machine.hoop_change_time')}
									<div>{this.props.state.detailed_calculation.details.machine.settings.hoop_change_time} {this.props.translate('global.units.seconds')}</div>
									</article>
									<article>
									{this.props.translate('global.form.label.machine.cone_change_time')}
									<div>{this.props.state.detailed_calculation.details.machine.settings.cone_change_time} {this.props.translate('global.units.seconds')}</div>
									</article>
									<article>
									{this.props.translate('global.form.label.machine.bobbin_stitch_count')}
									<div>{this.props.state.detailed_calculation.details.machine.settings.bobbin_stitch_count} {this.props.translate('global.units.stitches')}</div>
									</article>
									<article>
									{this.props.translate('global.form.label.machine.color_change_time')}
									<div>{this.props.state.detailed_calculation.details.machine.settings.color_change_time} {this.props.translate('global.units.seconds')}</div>
									</article>
									<article>
									{this.props.translate('global.form.label.machine.trimming_time')}
									<div>{this.props.state.detailed_calculation.details.machine.settings.trimming_time} {this.props.translate('global.units.seconds')}</div>
									</article>
									<article>
									{this.props.translate('global.form.label.machine.bobbin_change_time')}
									<div>{this.props.state.detailed_calculation.details.machine.settings.bobbin_change_time} {this.props.translate('global.units.seconds')}</div>
									</article>
									<article>
									{this.props.translate('global.form.label.machine.stitches_next_thread_break')}
									<div>{this.props.state.detailed_calculation.details.machine.settings.stitches_next_thread_break} {this.props.translate('global.units.stitches')}</div>
									</article>
									<article>
									{this.props.translate('global.form.label.machine.thread_break_fixing_time')}
									<div>{this.props.state.detailed_calculation.details.machine.settings.thread_break_fixing_time} {this.props.translate('global.units.seconds')}</div>
									</article>
									<article>
									{this.props.translate('global.form.label.machine.maintenance_cost')}
									<div>{this.props.settingsCompany.settings.currency ? this.props.settingsCompany.settings.currency.symbol : ""} {this.round(this.props.state.detailed_calculation.details.machine.settings.maintenance_cost,2)}</div>
									</article>
									<article>
									{this.props.translate('global.form.label.machine.investment')}
									<div>{this.props.settingsCompany.settings.currency ? this.props.settingsCompany.settings.currency.symbol : ""} {this.round(this.props.state.detailed_calculation.details.machine.investment,2)}</div>
									</article>
									<article>
									{this.props.translate('global.form.label.machine.amortization_months')}
									<div>{this.props.state.detailed_calculation.details.machine.amortization_months} {this.props.translate('global.units.months')}</div>
									</article>
									<article>
									{this.props.translate('global.form.label.machine.multihead')}
									<div>{this.props.state.detailed_calculation.details.machine.multihead ? (<div><Icon type="image" content="yes" size="10px" display="inline" /></div>) : (<div><Icon type="image" content="no" size="10px"  display="inline" /></div>)}</div>
									</article>
								</AccordionSection>
							</Accordion>
							<Spacer height="24px"/>
							<BoxTitle small>Calculations</BoxTitle>

							<Accordion>
						        <AccordionSection globalState={this.state.accordionState} title={this.props.translate('detailedcalculationmodal.details.base_calculations')}>

						            <article>{this.props.translate('detailedcalculationmodal.details.working_hours_per_year')}<div>{this.props.state.detailed_calculation.details.calculation.working_hours} {this.props.translate('global.units.hours')}</div>
						           	</article>
						           	<article>
			                		{this.props.translate('detailedcalculationmodal.details.machine_cost_per_hour')}<div>{this.props.settingsCompany.settings.currency ? this.props.settingsCompany.settings.currency.symbol : ""} {this.round(this.props.state.detailed_calculation.details.calculation.machine_hourly_cost,2)}</div>
						           	</article>
						           	<article>
			                		{this.props.translate('detailedcalculationmodal.details.general_cost_per_hour')}<div>{this.props.settingsCompany.settings.currency ? this.props.settingsCompany.settings.currency.symbol : ""} {this.round(this.props.state.detailed_calculation.details.calculation.fixed_hourly_cost,2)}</div>
						           	</article>
						           	<article>
			                		{this.props.translate('detailedcalculationmodal.details.production_cost_per_hour')}<div>{this.props.settingsCompany.settings.currency ? this.props.settingsCompany.settings.currency.symbol : ""} {this.round(this.props.state.detailed_calculation.details.calculation.production_hourly_cost,2)}</div>
						           	</article>
									<article>
			                		{this.props.translate('detailedcalculationmodal.details.total_amount_of_pieces')}<div>{this.props.state.detailed_calculation.details.calculation.total_pieces} {this.props.translate('global.units.pieces')}</div>
						           	</article>
						           	<article>
			                		{this.props.translate('detailedcalculationmodal.details.total_amount_of_stitches')}<div>{this.props.state.detailed_calculation.details.calculation.total_stitches} {this.props.translate('global.units.stitches')}</div>
						           	</article>
						           	<article>
			                		{this.props.translate('detailedcalculationmodal.details.total_amount_of_heads')}<div>{this.props.state.detailed_calculation.details.calculation.heads} {this.props.translate('global.units.heads')}</div>
			                		</article>
						        </AccordionSection>
						        <AccordionSection globalState={this.state.accordionState} title={this.props.translate('detailedcalculationmodal.details.machine_setup')} titleValue={secondsFormatter(this.props.state.detailed_calculation.details.calculation.total_setup_time,false,true)}>
						           	<article>
			                			{this.props.translate('detailedcalculationmodal.details.setup_time_per_head')}<div>{secondsFormatter(this.props.state.detailed_calculation.details.calculation.head_setup_time,false,true)}</div>
						           	</article>
						           	<article>
			                			{this.props.translate('detailedcalculationmodal.details.amount_of_heads')}<div><span>x </span>{this.props.state.detailed_calculation.details.calculation.heads} {this.props.translate('global.units.heads')}</div>
						           	</article>
						           	<article class="total">
			                			{this.props.translate('detailedcalculationmodal.details.needed_time_for_machine_setup')}<div>{secondsFormatter(this.props.state.detailed_calculation.details.calculation.total_setup_time,false,true)}</div>
			                		</article>
						        </AccordionSection>
						        <AccordionSection globalState={this.state.accordionState} title={this.props.translate('detailedcalculationmodal.details.stitches_during_setup')} titleValue={this.props.state.detailed_calculation.details.calculation.stitches_during_setup + ' ' + this.props.translate('global.units.stitches')} />
						    	<AccordionSection globalState={this.state.accordionState} title={this.props.translate('detailedcalculationmodal.details.machine_time_after_setup')} titleValue={secondsFormatter(this.props.state.detailed_calculation.details.calculation.total_machine_time,false,true)}>
						           	<article>
						    			{this.props.translate('detailedcalculationmodal.details.stitching_time')}<div>{secondsFormatter(this.props.state.detailed_calculation.details.calculation.total_stitch_time,false,true)}</div>
						           	</article>
						           	<article>
			                			{this.props.translate('detailedcalculationmodal.details.trimming_time')}<div><span>+ </span>{secondsFormatter(this.props.state.detailed_calculation.details.calculation.total_trim_time,false,true)}</div>
						           	</article>
						           	<article>
			                			{this.props.translate('detailedcalculationmodal.details.color_change_time')}<div><span>+ </span>{secondsFormatter(this.props.state.detailed_calculation.details.calculation.total_colorchange_time,false,true)}</div>
						           	</article>
						           	<article class="total">
			                			{this.props.translate('detailedcalculationmodal.details.needed_time_after_setup')}<div>{secondsFormatter(this.props.state.detailed_calculation.details.calculation.total_machine_time,false,true)}</div>
						           	</article>
						    	</AccordionSection>
						    	<AccordionSection globalState={this.state.accordionState} title={this.props.translate('detailedcalculationmodal.details.machine_down_time_during_production')} titleValue={secondsFormatter(this.props.state.detailed_calculation.details.calculation.total_down_time,false,true)}>
						           	<article>
			                			{this.props.translate('detailedcalculationmodal.details.bobbin_change_time')}<div>{secondsFormatter(this.props.state.detailed_calculation.details.calculation.total_bobbinchange_time,false,true)}</div>
						           	</article>
						           	<article>
			                			{this.props.translate('detailedcalculationmodal.details.time_to_fix_thread_breaks')}<div><span>+ </span>{secondsFormatter(this.props.state.detailed_calculation.details.calculation.total_threadbreak_time,false,true)}</div>
						           	</article>
						           	<article>
			                			{this.props.translate('detailedcalculationmodal.details.total_hoop_change_time')}<div><span>+ </span>{secondsFormatter(this.props.state.detailed_calculation.details.calculation.total_hoopchange_time,false,true)}</div>
						           	</article>
									<article>
			                			{this.props.translate('detailedcalculationmodal.details.total_idle_time')}<div><span>+ </span>{secondsFormatter(this.props.state.detailed_calculation.details.calculation.total_idle_time,false,true)}</div>
						           	</article>
									
						           	<article class="total">
			                			{this.props.translate('detailedcalculationmodal.details.total_down_time')}<div>{secondsFormatter(this.props.state.detailed_calculation.details.calculation.total_down_time,false,true)}</div>
						           	</article>
						    	</AccordionSection>
						    	<AccordionSection globalState={this.state.accordionState} title={this.props.translate('detailedcalculationmodal.details.hooping_and_garment_handling')} titleValue={secondsFormatter(this.props.state.detailed_calculation.details.calculation.total_working_time,false,true)}>
						           	<article>
			                			{this.props.translate('detailedcalculationmodal.details.working_time_per_piece')}<div>{secondsFormatter(this.props.state.detailed_calculation.details.calculation.working_time_per_piece,false,true)}</div>
						           	</article>
						           	<article>
			                			{this.props.translate('detailedcalculationmodal.details.amount_of_pieces')}<div><span>x </span>{this.props.state.detailed_calculation.details.calculation.total_pieces} {this.props.translate('global.units.pieces')}</div>
						           	</article>
						           	<article class="total">
			                		{this.props.translate('detailedcalculationmodal.details.needed_time_for_hooping_and_garment_handling')}<div>{secondsFormatter(this.props.state.detailed_calculation.details.calculation.total_working_time,false,true)}</div>
						           	</article>
						    	</AccordionSection>
						    	<AccordionSection theme="totalDouble" globalState={this.state.accordionState} title={this.props.translate('detailedcalculationmodal.details.total_production_time')} titleValue={secondsFormatter(this.props.state.detailed_calculation.details.calculation.total_production_time,false,true)} />
						    	<AccordionSection theme="total" globalState={this.state.accordionState} title={this.props.translate('detailedcalculationmodal.details.total_production_cost')} titleValue={(this.props.settingsCompany.settings.currency ? this.props.settingsCompany.settings.currency.symbol : "") + ' ' + this.round(this.props.state.detailed_calculation.details.calculation.total_production_cost,2)} />
						    	<AccordionSection theme="total" globalState={this.state.accordionState} title={this.props.translate('detailedcalculationmodal.details.total_production_time_per_piece')} titleValue={secondsFormatter(this.props.state.detailed_calculation.details.calculation.production_time_per_piece,false,true)} />
						    	<AccordionSection theme="total" globalState={this.state.accordionState} title={this.props.translate('detailedcalculationmodal.details.total_production_cost_per_piece')} titleValue={(this.props.settingsCompany.settings.currency ? this.props.settingsCompany.settings.currency.symbol : "") + ' ' + this.round(this.props.state.detailed_calculation.details.calculation.production_cost_per_piece,2)} />
						    </Accordion>
		                </GreyBox>
		            </Modal>
	    		)
	    	}));
    	}
    }

    render () {
    	 return this.state.modalContent
   	}
}

const mapStateToProps = state => {
    return {
        defaults: state.defaults,
        state: state.calculatorJob,
        translate: getTranslate(state.locale),
        settingsCompany: state.calculatorSettingsCompany
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onCalculatorJobDetailedCalculation: (jobId, calculationId) => dispatch(actionCreators.calculatorJobDetailedCalculation(jobId, calculationId)),
        onCalculatorJobDetailedCalculationReset: () => dispatch(actionCreators.calculatorJobDetailedCalculationReset())
    }
};
export default connect(mapStateToProps, mapDispatchToProps)(withErrorHandler(DetailedCalculationModal, axios));

                    


// WEBPACK FOOTER //
// ./src/components/pages/JobPage/DetailedCalculationModal/index.js